.pill {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: var(--mantine-spacing-3xs) var(--mantine-spacing-sm);
    border-radius: 999px;
    cursor: pointer;
    transition:
        border-color 0.5s ease,
        background-color 0.5s ease;
    border: 2px solid transparent;
}

.neutral {
    border-color: var(--mantine-color-dark-4);
}

.onTrack {
    border-color: var(--mantine-color-teal-5);
    background-color: color-mix(in srgb, var(--mantine-color-teal-4) 50%, transparent);
}

.onTrack:hover {
    background-color: color-mix(in srgb, var(--mantine-color-teal-4) 40%, transparent);
}

.onTrack:active {
    background-color: color-mix(in srgb, var(--mantine-color-teal-4) 30%, transparent);
}

.approaching {
    border-color: var(--mantine-color-yellow-5);
    background-color: color-mix(in srgb, var(--mantine-color-yellow-4) 50%, transparent);
}

.approaching:hover {
    background-color: color-mix(in srgb, var(--mantine-color-yellow-4) 40%, transparent);
}

.approaching:active {
    background-color: color-mix(in srgb, var(--mantine-color-yellow-4) 30%, transparent);
}

.exceeded {
    border-color: var(--mantine-color-red-5);
    background-color: color-mix(in srgb, var(--mantine-color-red-4) 50%, transparent);
    animation: pacingExceededPulse 2.4s ease-in-out infinite;
}

.exceeded:hover {
    background-color: color-mix(in srgb, var(--mantine-color-red-4) 40%, transparent);
}

.exceeded:active {
    background-color: color-mix(in srgb, var(--mantine-color-red-4) 30%, transparent);
}

@keyframes pacingExceededPulse {
    0%,
    100% {
        box-shadow: 0 0 0 0 color-mix(in srgb, var(--mantine-color-red-5) 0%, transparent);
    }
    50% {
        box-shadow: 0 0 8px 2px color-mix(in srgb, var(--mantine-color-red-5) 55%, transparent);
    }
}

@media (prefers-reduced-motion: reduce) {
    .exceeded {
        animation: none;
    }
}

.timerText {
    cursor: pointer;
    font-weight: 600;
    letter-spacing: 0.02em;
}
